var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.957 13.731H5.418a.692.692 0 0 1-.692-.692v-5.49l-.9.692a.69.69 0 0 1-.977 0L.89 6.316a.69.69 0 0 1 0-.976l4.071-4.071h1.15c0 .761.927 1.384 2.077 1.384 1.149 0 2.077-.623 2.077-1.384h1.149l4.071 4.07a.69.69 0 0 1 0 .977l-1.96 1.96a.702.702 0 0 1-.976 0l-.9-.693v5.456c0 .382-.31.692-.692.692",
    fill: "#BABFCB",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.dee97b26.svg";
export { ForwardRef as ReactComponent };